import { render, staticRenderFns } from "./floor-style-ermei-design-3.vue?vue&type=template&id=05ce9829&scoped=true"
import script from "./floor-style-ermei-design-3.vue?vue&type=script&lang=js"
export * from "./floor-style-ermei-design-3.vue?vue&type=script&lang=js"
import style0 from "./floor-style-ermei-design-3.vue?vue&type=style&index=0&id=05ce9829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce9829",
  null
  
)

export default component.exports